<template>
  <div
    v-cursor="permission ? 'pointer' : 'default'"
    :class="$style.container"
    @click="handleClick"
  >
    <div :class="$style.status">
      <base-icon
        v-color:black-2
        name="basic_eagle_filled"
      />
    </div>

    <div
      :class="$style.content"
      v-text="$t('common.declared')"
    />

    <div v-if="permission" :class="$style.action">
      <base-icon
        v-color:violet
        name="file_note-text"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransactionDeclared',
  props: {
    permission: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    handleClick() {
      if (this.permission) {
        this.$emit('show-check');
      }
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +align-items(center)
    +size(100%, auto)

  .status
    +flexbox
    margin-right: 26px

  .content
    +font-type('semi-bold', 14, 20)

  .action
    +flexbox
    margin-left: auto
</style>
